<template>
    <div class="addCategoriesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular
                class="mt-auto"
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <div v-else class="row">
            <div  class="col-md-7">
                <v-form 
                    ref="form" 
                    lazy-validation 
                    class="mt-5 col-sm-8 col-md-8"
                    >
                    <v-text-field
                        :label="$t('board.label.mode.title')"
                        color="secondary"
                        v-model=formData.nombreModo
                        readonly
                        disabled
                    ></v-text-field>

                    <v-select
                        :label="'*'+$t('board.label.categoryBenefit.title')" 
                        :placeholder="$t('board.label.categoryBenefit.text')" 
                        color="secondary"
                        required
                        :items="categoriasBeneficios"
                        item-text="descripcion"
                        item-value="idCategoriaBeneficio"
                        :rules="categoryBenefitRules"
                        v-model="formData.idCategoriaBeneficio"
                    ></v-select>

                    <v-select
                        :label="'*'+$t('board.label.typeCategory.title')" 
                        :placeholder="$t('board.label.typeCategory.text')" 
                        color="secondary"
                        required
                        :items="tipoCategoria"
                        item-text="nombre"
                        item-value="idTipoCategoriaComercial"
                        :rules="typeRules"
                        v-model="formData.idTipoCategoriaComercial"
                    ></v-select>

                    <v-text-field
                        :label="'*'+$t('board.label.nameCategory.title')" 
                        :placeholder="$t('board.label.nameCategory.text')" 
                        color=secondary
                        required
                        :counter="25" 
                        :maxlength="25"
                        :rules="nameRules"
                        v-model="formData.nombre"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('board.label.description.title')" 
                        :placeholder="$t('board.label.description.text')" 
                        color=secondary
                        :counter="40"
                        :maxlength="40"
                        required
                        :rules="descriptionRules"
                        v-model="formData.descripcion"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('board.label.responsible.title')" 
                        :placeholder="$t('board.label.responsible.text')" 
                        color=secondary
                        required
                        :counter="40" 
                        :maxlength="40"
                        :rules="responsibleRules"
                        v-model="formData.responsable"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('label.phone.title')" 
                        :placeholder="$t('label.phone.text')" 
                        color="secondary"
                        required
                        :rules="phoneRules"
                        v-model="formData.telefono"
                        @keydown="handleKeyDown"
                        inputmode="numeric"
                        pattern="[0-9]{0,15}"
                        :counter="15"
                        :maxlength="15"
                    ></v-text-field>

                    <v-text-field
                        :label="'*'+$t('label.email.title')" 
                        :placeholder="$t('label.email.text')" 
                        color=secondary
                        required
                        :counter="200" 
                        :maxlength="200"
                        :rules="mailRules"
                        v-model="formData.correo"
                    ></v-text-field>
                </v-form>

                <div class="img-btn">
                    <div>
                        <changeImage/>
                    </div>
                    <v-tooltip left>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                fab
                                fixed
                                bottom
                                right
                                dark
                                large
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                @click="submitForm"
                                >
                                <v-icon dark>mdi-content-save</v-icon>
                            </v-btn>

                        </template>

                        <span>{{ $t('button.save') }}</span>

                    </v-tooltip>  
                </div>

            </div>
            
        </div>
    </div>
</template>

<script>

    import  EventBus  from '@/utils/event_bus.js'; 
    import { mapActions, mapGetters } from "vuex";
    import changeImage from "@/shared/components/icons_selector/change_image_component.vue";
    import {
        BOARD_M,
        GET_CATEGORIES_BENEFITS,
        GET_CATEGORY_TYPE,
        GET_STATE_LOADING,
        GET_MODO,
        ACTION_GET_MODE,
        ACTION_GET_CATEGORIES_BENEFITS,
        ACTION_GET_CATEGORY_TYPE,
        ACTION_POST_CREATE_CATEGORIES,
    } from "@/views/categories_board/store/types/types.js";
    import i18n from '@/plugins/i18n';
    import Swal from "sweetalert2";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    export default {

        components: {
            changeImage
        },

        name:"addCategoriesComponent",
        data() {
            return {
                formData: {
                    idCategoriaBeneficio: null,
                    nombreModo: null,
                    idTipoCategoriaComercial: null,
                    idImagenCategoria:null,
                    nombre: '',
                    descripcion: '',
                    responsable: '',
                    telefono: '',
                    correo: '',
                    idModo: null,
                },
                categoryBenefitRules: [
                    v => !!v || this.$t('board.label.categoryBenefit.required')
                ],
                typeRules: [
                    v => !!v || this.$t('board.label.typeCategory.required')
                ],
                nameRules: [
                    v => !!v  || this.$t('board.label.nameCategory.required')
                ],
                descriptionRules: [
                    v => !!v || this.$t('board.label.description.required')
                ],
                responsibleRules: [
                    v => !!v || this.$t('board.label.responsible.required')
                ],
                phoneRules: [
                    v => !!v || this.$t('label.phone.required'),
                    v => (v && v.length >= 7 && v.length <= 15) || this.$t('label.phone.maxLength')
                ],
                mailRules: [
                    v => !!v || this.$t('label.email.required'),
                    v => emailRegex.test(v) || this.$t('label.email.invalid')
                ],
                categoriaBeneficioList:[],
                categoriasBeneficios:[],
                tipoCategoria:[],
                showErrorMessages: false
            };
        },

        async mounted() {

            // id del modo
            await this.getMode();
            const modos = await this.modes
            const id = modos[1].idModoCategoria;

            // lista categorias beneficios
            this.categoriaBeneficioList = await this.getCategoriaBeneficio(id);
            this.categoriasBeneficios = this.categoriaBeneficioList.payload;
            
            if (this.categoriaBeneficioList.payload) {
                                
                this.formData.idModo = modos[1].idModoCategoria;
                this.formData.nombreModo = modos[1].nombre;
            }

            // lista de los tipos de categorias
            this.tipoCategoria = await this.getTipoCategoria(id);

            // Escucha el evento emitido por el componente hijo
            EventBus.$on('icon-selected', (iconId) => {

                this.formData.idImagenCategoria = iconId;
                
            });

            // Escuchar evento para limpiar el formulario cuando el diálogo se cierra
            EventBus.$on('clear-categories-form', this.clearForm);
        },

        beforeDestroy() {
            // Limpiar el event listener
            EventBus.$off('clear-categories-form', this.clearForm);
        },

        methods: {

            async getTipoCategoria(id) {
                const response = await this.getTipoCategoriaBoard(id);
                return response;
            },

            clearForm() {
                // Resetear formData
                this.formData = {
                    idCategoriaBeneficio: null,
                    nombreModo: null,
                    idTipoCategoriaComercial: null,
                    idImagenCategoria: null,
                    nombre: '',
                    descripcion: '',
                    responsable: '',
                    telefono: '',
                    correo: '',
                    idModo: null,
                };
                
                // Resetear validación del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }
            },
            
            handleKeyDown(event) {
                // Permite solo números y la tecla de borrar
                if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                    event.preventDefault();
                }
            },

            ...mapActions({
                getMode: `${BOARD_M}${ACTION_GET_MODE}`,
                getCategoriaBeneficio: `${BOARD_M}${ACTION_GET_CATEGORIES_BENEFITS}`,
                getTipoCategoriaBoard: `${BOARD_M}${ACTION_GET_CATEGORY_TYPE}`,
                postCrearCategoria: `${BOARD_M}${ACTION_POST_CREATE_CATEGORIES}`,
            }),

            async submitForm() {

                const validationErrors = this.validateForm();

                if (Object.keys(validationErrors).length > 0) {
                    const errorMessages = Object.values(validationErrors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.errorsValidation.plural.title'),
                        html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                        confirmButtonColor: '#6E17A5'
                    });

                    return;
                }

                const save = await this.postCrearCategoria(this.formData);
                if(!save){

                    return Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.invalid.title'),
                        text: i18n.t('label.invalid.text')
                    })

                }
                await this.clearForm();
                
                EventBus.$emit('form-submitted-successfully');

            },

            validateForm() {
                
                this.showErrorMessages = true

                // Expresión regular para validar que no consista solo en espacios en blanco o tabulaciones
                const notOnlyWhitespaceRegex = /\S/;

                const errors = {};

                if (!this.formData.idCategoriaBeneficio) {
                    errors.idCategoriaBeneficio = this.$t('board.label.categoryBenefit.title');
                }

                if (!this.formData.idTipoCategoriaComercial) {
                    errors.idTipoCategoriaComercial = this.$t('board.label.typeCategory.title');
                }

                if (!this.formData.nombre || !this.formData.nombre.trim()) {
                    errors.nombre = this.$t('board.label.nameCategory.title');
                }

                if (!this.formData.descripcion || !this.formData.descripcion.trim() ) {
                    errors.descripcion = this.$t('board.label.description.title');
                }

                if (!this.formData.responsable || !notOnlyWhitespaceRegex.test(this.formData.responsable)) {
                    errors.responsable = this.$t('board.label.responsible.title');
                }

                if (!this.formData.telefono || !/^[0-9]{7,15}$/.test(this.formData.telefono)) {
                    errors.telefono = this.$t('label.phone.title');
                }

                if (!this.formData.correo || !emailRegex.test(this.formData.correo) || this.formData.correo.length > 200) {
                    errors.correo = this.$t('label.email.title');
                }

                if (!this.formData.idImagenCategoria) {
                    errors.idImagenCategoria = this.$t('board.label.imageCategory');
                }

                return errors;
            }, 
        },
    
        computed: {

            ...mapGetters({
                modes: `${BOARD_M}${GET_MODO}`,
                categorias_beneficios: [`${BOARD_M}${GET_CATEGORIES_BENEFITS}`], 
                tipo_categorias: [`${BOARD_M}${GET_CATEGORY_TYPE}`],
                loading: `${BOARD_M}${GET_STATE_LOADING}`,
            }),

        },
    };

</script>


<style lang="css" scoped>

    /* Css input imagen*/

    .col-md-7 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap:230px;
    }
    .row {
        display: flex;
        justify-content: center;
    }

    /*Resposive*/
    @media screen and (max-width: 912px) {
        .col-md-7 {
            gap:40px;
        }
    }
    @media screen and (max-width: 820px) {
        .col-md-7 {
            gap:40px;
        }
    }

    @media screen and (max-width: 768px) {
        .col-md-7 {
            gap:40px;
        }
    }
    @media screen and (max-width: 425px) {
        .col-md-7 {
            gap:10px;
            display: flex;
            flex-direction: column-reverse;
        } 
    }

</style>